/* --------------------------------------------------------------------------------------
   filetype.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { pdfSearchLanguages } from "../constants/jobSettings.const"

const browserLanguage = navigator.language.slice(0, 2);
const defaultLanguage = pdfSearchLanguages.find(language => language.key.slice(0, 2) === browserLanguage).key.slice(0, 2) || 'en'

export const defaultFiletypeSettings = {
    extension: 'pdf',
    searchable: true,
    language: defaultLanguage,
    combine: false,
    archival: false
}
